import { useEffect, useRef } from 'react'

import {
  generalTimeFormat,
  getCurrentTime,
  setInitialTime,
} from 'Common/utils/datetime'

export default function useElapsingTime({
  timeLimit = null,
  timeLimitUnit = 'minute',
  handleTimeOver,
  updateTimeCallback,
  shouldStartTimer = null,
} = {}) {
  const elapsedTime = useRef(null)
  const initialTime = useRef(setInitialTime({ minute: 0, second: 0 }))

  const stopTimer = () => {
    clearInterval(elapsedTime.current)
  }

  const startTimer = () => {
    let time = initialTime.current

    elapsedTime.current = window.setInterval(() => {
      time = time.add(1, 'seconds')

      if (
        timeLimit &&
        timeLimit === getCurrentTime({ dateTime: time, unit: timeLimitUnit })
      ) {
        stopTimer()
        handleTimeOver()
      }

      updateTimeCallback(generalTimeFormat(time, 'mm:ss'))
    }, 1000)
  }

  // this is an alternative approach to the auxiliary methods
  // startTimer and stopTimer, in case you need to pass in a flag
  // instead of calling the methods.
  useEffect(() => {
    shouldStartTimer ? startTimer() : stopTimer()
  }, [shouldStartTimer])

  return {
    startTimer,
    stopTimer,
  }
}
